
export class GlobalClientVariables {
    serverUpdated: boolean = false
}
